import React, { Fragment } from "react";
import Header from "../component/layout/header";
import Footer from "../component/layout/footer";
import {
  ShieldCheck,
  Info,
  Eye,
  Lock,
  Database,
  UserCheck,
  MessageSquare,
  Clock,
  FileText,
} from "lucide-react";

const PrivacyPolicyPage = () => {
  const policySections = [
    {
      id: 1,
      title: "1. Your Consent",
      icon: <UserCheck size={20} />,
      color: "#ff4d88",
      content:
        "By accessing or using the Kalakakshaaha Platform on a continued basis, you expressly consent to the collection, storage, processing, usage, and disclosure of your information in accordance with this Privacy Policy.",
    },
    {
      id: 2,
      title: "2. Our Commitment to Privacy",
      icon: <ShieldCheck size={20} />,
      color: "#ff884d",
      content:
        "Kalakakshaaha values the trust you place in us and is committed to safeguarding your personal information. This policy applies to all users including tutors, students, institutes, and visitors. We are not responsible for the privacy practices of third-party websites linked from our Platform.",
    },
    {
      id: 3,
      title: "3. Information We Collect",
      icon: <Database size={20} />,
      color: "#4da6ff",
      content:
        "We collect information only when you voluntarily provide it or when required for platform operations.",
      list: [
        "Personal details such as name, email, mobile number, gender, and location",
        "Tutor and institute details including qualifications, skills, availability, pricing, and profile photo",
        "Student learning requirements and preferences",
        "Payment-related information processed via secure third-party gateways",
        "User-generated content such as messages, reviews, images, videos, and documents",
      ],
    },
    {
      id: 4,
      title: "4. Non-Personal Information",
      icon: <Eye size={20} />,
      color: "#33cc99",
      list: [
        "Browser type and operating system",
        "IP address and internet service provider",
        "Pages visited, session duration, and navigation patterns",
      ],
    },
    {
      id: 5,
      title: "5. Cookies & Session Data",
      icon: <Info size={20} />,
      color: "#ff6666",
      content:
        "Kalakakshaaha uses cookies and session data to enhance user experience, remember preferences, analyze traffic, diagnose technical issues, and ensure legal compliance. Disabling cookies may limit certain platform features.",
    },
    {
      id: 6,
      title: "6. How We Use Your Information",
      icon: <FileText size={20} />,
      color: "#ff9933",
      list: [
        "To provide, manage, and improve our services",
        "To connect students with suitable tutors",
        "To process payments and tutor payouts",
        "To respond to support requests and inquiries",
        "To ensure platform safety and policy compliance",
        "To conduct analytics and research",
      ],
    },
    {
      id: 7,
      title: "7. Recording of Calls & Online Sessions",
      icon: <MessageSquare size={20} />,
      color: "#66b3ff",
      content:
        "Calls, demo sessions, and online classes conducted through the Platform may be recorded for quality assurance, training, and compliance purposes. These recordings are used strictly for internal purposes only.",
    },
    {
      id: 8,
      title: "8. Data Security",
      icon: <Lock size={20} />,
      color: "#33cc99",
      content:
        "Kalakakshaaha follows industry-standard security practices to protect personal information. Access to data is restricted to authorized personnel. However, no online platform can guarantee complete security.",
    },
    {
      id: 9,
      title: "9. User Content Responsibility",
      icon: <Eye size={20} />,
      color: "#cc66ff",
      content:
        "Content shared publicly by users may be visible to others. Kalakakshaaha does not guarantee confidentiality of publicly shared content and is not responsible for misuse by third parties.",
    },
    {
      id: 10,
      title: "10. Account Closure & Data Retention",
      icon: <Clock size={20} />,
      color: "#9999ff",
      content:
        "You may close your account at any time. Certain information may be retained for legal, audit, fraud prevention, or legitimate business purposes even after account deletion.",
    },
    {
      id: 11,
      title: "11. Children’s Privacy",
      icon: <UserCheck size={20} />,
      color: "#ff6666",
      content:
        "Kalakakshaaha services are intended for users aged 10 years and above. Minors are not permitted to register independently. Parents or guardians may contact us for immediate removal of a minor’s data.",
    },
    {
      id: 12,
      title: "12. Changes to This Privacy Policy",
      icon: <Info size={20} />,
      color: "#be46d9ff",
      content:
        "Kalakakshaaha may update this Privacy Policy from time to time. Changes are effective immediately upon posting. Continued use of the Platform constitutes acceptance of the updated policy.",
    },
  ];

  return (
    <Fragment>
      <Header />

      <main className="kks-dark-wrapper">
        <div className="kks-contact-container">
          <div className="kks-main-card">
            {/* Header */}
            <div className="kks-header-section">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "15px",
                }}
              >
                
              </div>
               <h3 style={{ color: "#ffffffff",fontSize: "40px" }}>Privacy Policy</h3>
              <p>
               This Privacy Policy is issued in accordance with the Information Technology Act, 2000 and applicable rules thereunder. Kalakakshaaha is committed to protecting the privacy of users who access or use our website, mobile applications, and services.
              </p>
            </div>

            <div className="kks-grid" style={{ gridTemplateColumns: "1fr" }}>
              <div className="kks-form-area" style={{ width: "100%" }}>
                {policySections.map((section) => (
                  <div
                    key={section.id}
                    className="policy-block-item"
                    style={{ marginBottom: "20px" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        marginBottom: "15px",
                      }}
                    >
                      <span style={{ color: section.color }}>
                        {section.icon}
                      </span>
                      <h2
                        style={{
                          fontSize: "24px",
                          color: section.color,
                          margin: 0,
                        }}
                      >
                        {section.title}
                      </h2>
                    </div>

                    {section.content && (
                      <p style={{ color: "#ccc" }}>{section.content}</p>
                    )}

                    {section.list && (
                      <ul style={{ listStyle: "none", paddingLeft: "5px" }}>
                        {section.list.map((item, index) => (
                          <li
                            key={index}
                            style={{
                              color: "#ece8e8ff",
                              marginBottom: "8px",
                              display: "flex",
                              alignItems: "start",
                            }}
                          >
                            <span
                              style={{
                                color: section.color,
                                marginRight: "10px",
                              }}
                            >
                              •
                            </span>
                            {item}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </main>

      <style>{`

      @media (max-width: 768px) {
 
.policy-block-item {
padding: 10px !important;
      }
.kks-header-section h3 {
    font-size: 35px !important;
  }
      }
        .policy-block-item {
          background: rgba(255, 255, 255, 0.03);
          padding: 25px;
          border-radius: 12px;
          border: 1px solid rgba(255, 255, 255, 0.05);
          transition: transform 0.3s ease;
        }
        .policy-block-item:hover {
          transform: translateY(-5px);
          background: rgba(255, 255, 255, 0.05);
        }
        .kks-header-section h1 {
          margin-top: 10px;
        }
      `}</style>

      <Footer />
    </Fragment>
  );
};

export default PrivacyPolicyPage;
